<template>
    <div class="login_box" v-loading="loading">
        <div class="login_flex">
            <div class="login_lefts">
                <div class="login_title">
                    做一个有口碑的<span>法律裁判点评网</span>
                </div>
                <div class="login_text">
                    全面支持法律服务在线下单，金牌云律师智库在线查询海量合同模板免费下载，各类法律资讯实时推送聚焦社会热点问题，让法律服务更加融入我们的生活全面支持法律服务在线下单，金牌云律师智库在线查询海量合同模板免费下载，各类法律资讯实时推送聚焦社会热点问题，让法律服务更加融入我们的生活
                </div>
            </div>
            <div class="login_rights">
                <div class="login_form" v-if="type_show==1">
                    <div class="login_type" @click="handle_type(2)">
                        <img src="@/assets/img/login/code_login.png" alt="">
                    </div>
                    <div class="titles">账号登录</div>
                    <div class="type_box" >
                        <div class="type_check" :class="{user_type_ac:user_type_ac==1}" @click="handle_user_type(1)">
                            <div class="texts">个人会员</div>
                            <div class="borders"></div>
                        </div>
                        <div class="type_check" :class="{user_type_ac:user_type_ac==2}" @click="handle_user_type(2)">
                            <div class="texts">企业会员</div>
                            <div class="borders"></div>
                        </div>
                    </div>
                    <div class="form_box">
                        <div class="input_box">
                            <div class="texts">手机号</div>
                            <div class="borders"></div>
                            <div class="inputs">
                                <input type="text" v-model="form.mobile" placeholder="请输入手机号">
                            </div>
                        </div>
                        <div class="input_box">
                            <div class="texts">密码</div>
                            <div class="borders"></div>
                            <div class="inputs">
                                <input type="password" v-model="form.password" placeholder="请输入密码">
                            </div>
                        </div>
                    </div>
                    <div class="password_box">
                        <div class="pass1">
                            <el-checkbox v-model="pass_ac">记住密码</el-checkbox>
                        </div>
                        <div class="pass2" @click="handle_password">
                            忘记密码
                        </div>
                    </div>
                    <div class="btns_box">
                        <div class="btns" @click="handle_login">登 录</div>
                    </div>
                    <div class="agree_box">
                        <el-checkbox v-model="agree_ac"></el-checkbox>
                        &nbsp;&nbsp;我已阅读并同意
                        <span @click="handle_xy">《隐私政策》</span>
                        <span @click="handle_xy2">《客户协议》</span>
                        <span @click="handle_xy3">《第三方个人信息处理规则》</span>
                    </div>
                    <div class="border_box"></div>
                    <div class="enroll_box">
                        还没账号，<span @click="handle_enroll">去注册</span>
                    </div>
                </div>
                <div class="login_code"  v-if="type_show==2">
                    <div class="login_type" @click="handle_type(1)">
                        <img src="@/assets/img/login/pass_login.png" alt="">
                    </div>
                    <div class="titles">微信扫码登录</div>
                    <div class="code_img">
                        <img src="@/assets/img/login/code.png" alt="">
                    </div>
                    <div class="wx_tx_box">
                        <div class="wx_img">
                            <img src="@/assets/img/login/wx.png" alt="">
                        </div>
                        <div class="wx_text">请使用微信扫一扫登录</div>
                    </div>
                </div>
            </div>
        </div>        
        <agreement ref="agreement"  @handle_end="handle_end"></agreement>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'
export default {
    components: {
    },
    name: "homes",
    data() {
        return {
            loading:false,
            type_show:1,//1账号登录 2扫码登录
            user_type_ac:1,//1个人2企业
            pass_ac:false,//记住密码
            agree_ac:false,//隐私

            form:{
                mobile:'15231207781',
                password:123456,
            }
        }
    },
    computed: {
       
    },
    watch: {

    },
    created() {
        
        let login_form=localStorage.getItem('login_form')
        if(login_form){
            this.form=JSON.parse(login_form)
        }
    },
    methods: {
        //登录切换
        handle_type(i){
            this.type_show=i
        },
        //身份切换
        handle_user_type(i){
            this.user_type_ac=i
        },
        //查看协议
        handle_xy(){
            this.$refs.agreement.handle_open()
        },
        handle_xy2(){
            this.$refs.agreement.handle_open('customer_agreement')
        },
        handle_xy3(){
            this.$refs.agreement.handle_open('personal_rule')
        },
        //同意协议
        handle_end(){
            this.agree_ac=true
        },
        //去注册
        handle_enroll(){
            this.$router.push({
                path:'/enroll'
            })
        },
        //忘记密码
        handle_password(){
            this.$router.push({
                path:'/password'
            })
        },
        //登录成功
        handle_login(){

            if(!this.agree_ac){
                alertErr('请阅读隐私协议')
                return
            }
            if(!this.form.mobile){
                alertErr('请输入手机号')
                return
            }
            let reg = /^((11[0-9])|(12[0-9])|(13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))\d{8}$/;
            if (!reg.test(this.form.mobile)) {
                alertErr('请输入正确的手机号')
                return 
            }
            if(!this.form.password){
                alertErr('请输入密码')
                return
            }
            this.$api("web_login", {
				...this.form,
                log_type:this.user_type_ac,
			}, "post").then((res) => {
                this.loading = false
                console.log('登录',res)
                if (res.code == 1) {
                    if(this.pass_ac){
                        localStorage.setItem('login_form',JSON.stringify(this.form))
                    }
                    if(res.data.type){
                        localStorage.setItem('token',res.data.token)
                        this.$store.dispatch("appInit"); //重新初始化
                        this.$store.dispatch("query_user"); //获取用户信息
                        
                        this.$router.push({
                            path:'/user_grzx',
                        })
                    }else{
                        this.$store.dispatch("appInit"); //重新初始化
                        this.$router.push({
                            path:'/login_info',
                            query:{
                                token:res.data.token,
                                mobile:this.form.mobile,
                                log_type:this.user_type_ac,
                            }
                        })
                    }
                } else {
                    alertErr(res.msg)
                }
            });
           
        },


    },

}
</script>
<style scoped lang="less">
.login_box {
    width: 100%;
    height: 680px;
    background-image: url('../../assets/img/login/login_bg.png');
    background-size:100% 100%;
    .login_flex{
        width: 1440px;
        height: 100%;
        margin: auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .login_lefts{
            .login_title{
                font-family: HGJZY, HGJZY;
                font-weight: 400;
                font-size: 48px;
                color: #222222;
                padding-bottom: 63px;
                span{
                    color: #377CFD;
                }

            }
            .login_text{
                width: 608px;
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 16px;
                color: #666666;
                line-height: 48px;
            }
        }
        .login_rights{
            .login_form{
                width: 480px;
                height: 512px;
                background: #FFFFFF;
                box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.16);
                border-radius: 12px 12px 12px 12px;
                position: relative;
                padding:  32px 40px 24px 40px ;
                .login_type{
                    position: absolute;
                    top: 14px;
                    right: 12px;
                    img{
                        width: 64px;
                        height: 64px;
                        cursor: pointer;
                    }
                }
                .titles{
                    text-align: center;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 20px;
                    color: #333333;

                }
                .type_box{
                    display: flex;
                    align-items: center;
                    justify-content: space-evenly;
                    .type_check{
                        padding-top: 36px;
                        cursor: pointer;
                        .texts{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 18px;
                            color: #666666;
                        }
                        .borders{
                            width: 32px;
                            height: 4px;
                            background: #FFFFFF;

                            border-radius: 4px 4px 4px 4px; 
                            margin: auto;
                            margin-top: 10px;
                        }
                        &:hover{
                            .texts{
                                color: #377CFD;
                            }
                            .borders{
                                background: #377CFD;
                            }  
                        }

                    }
                    .user_type_ac{
                        .texts{
                            color: #377CFD;
                        }
                        .borders{
                            background: #377CFD;
                        }   
                    }
                }
                .form_box{
                    padding-top: 30px;
                    .input_box{
                        width: 400px;
                        height: 40px;
                        background: #FFFFFF;
                        border-radius: 4px 4px 4px 4px;
                        border: 1px solid #EEEEEE;
                        display:flex ;
                        align-items: center;
                        margin-bottom: 20px;
                        .texts{
                            font-weight: 400;
                            font-size: 14px;
                            color: #7D7D7D;
                            // padding: 0 24px;
                            width: 90px;
                            flex-shrink: 0;
                            text-align: center;
                        }
                        .borders{
                            width: 1px;
                            height: 18px;
                            background: #EEEEEE;
                            border-radius: 0px 0px 0px 0px;
                        }
                        .inputs{
                            flex: 1;
                            padding: 0 17px;
                            font-size: 14px;
                            input{
                                width: 100%;
                            }
                        }
                        .btns{
                            cursor: pointer;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 14px;
                            color: #377CFD;
                            padding-right:16px;
                        }
                    }
                }
                .password_box{
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    .pass1{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #999999;
                    }
                    .pass2{
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #377CFD;
                        cursor: pointer;
                    }
                }
                .btns_box{
                    margin-top: 48px;

                    .btns{
                        width: 400px;
                        height: 44px;
                        background: #377CFD;
                        border-radius: 4px 4px 4px 4px;
                        text-align: center;
                        line-height: 44px;
                        cursor: pointer;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 18px;
                        color: #FFFFFF;
                    }
                   
                }
                .agree_box{
                    padding-top: 14px;
                    display: flex;
                    align-items: center;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 12px;
                    color: #999999;
                    text-wrap: nowrap;
                    span{
                        color: #377CFD;
                        text-wrap: nowrap;
                        cursor: pointer;
                    }
                }
                .border_box{
                    width: 400px;
                    height: 1px;
                    background: #E5E5E5;
                    border-radius: 0px 0px 0px 0px;
                    margin-top: 30px;
                }
                .enroll_box{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 14px;
                    color: #666666;
                    text-align: center;
                    padding-top: 15px;
                    span{
                        color: #377CFD;
                        cursor: pointer;
                    }
                }
            }
            .login_code{
                width: 480px;
                height: 458px;
                background: #FFFFFF;
                box-shadow: 0px 3px 6px 1px rgba(0,0,0,0.16);
                border-radius: 12px 12px 12px 12px;
                position: relative;
                padding:  32px 40px 24px 40px ;
                .login_type{
                    position: absolute;
                    top: 14px;
                    right: 12px;
                    img{
                        width: 64px;
                        height: 64px;
                        cursor: pointer;
                    }
                }
                .titles{
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: bold;
                    font-size: 20px;
                    color: #333333;
                    text-align: center;

                }
                .code_img{
                    padding: 54px;
                    text-align: center;
                    img{
                        width: 168px;
                        height: 168px;
                        cursor: pointer;
                    }
                }
                .wx_tx_box{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .wx_img{
                        img{
                            width: 32px;
                            height: 32px;
                        }
                    }
                    .wx_text{
                        padding-left: 8px;
                        font-weight: 400;
                        font-size: 16px;
                        color: #333333;
                    }
                }
            }
        }
    }
}
</style>